export default __webpack_public_path__ + "static/media/user.0a4ae0bf.png";